import React from 'react';

/**
 * DraftRestoreBanner
 * Shown at the top of a form when a saved draft is detected in localStorage.
 *
 * Props:
 *   savedAt   {number}   - Unix timestamp (ms) when the draft was saved
 *   onRestore {function} - Called when user clicks "Restore"
 *   onDiscard {function} - Called when user clicks "Discard"
 */
function DraftRestoreBanner({ savedAt, onRestore, onDiscard }) {
  const timeLabel = React.useMemo(() => {
    if (!savedAt) return 'earlier';
    const diffMs = Date.now() - savedAt;
    const diffMin = Math.floor(diffMs / 60000);
    if (diffMin < 1) return 'just now';
    if (diffMin < 60) return `${diffMin} minute${diffMin === 1 ? '' : 's'} ago`;
    const diffHr = Math.floor(diffMin / 60);
    return `${diffHr} hour${diffHr === 1 ? '' : 's'} ago`;
  }, [savedAt]);

  return (
    <div className="draft-restore-banner" role="alert">
      <span>You have an unsaved draft from {timeLabel}.</span>
      <button className="draft-btn-restore" onClick={onRestore}>
        Restore
      </button>
      <button className="draft-btn-discard" onClick={onDiscard}>
        Discard
      </button>
    </div>
  );
}

export default DraftRestoreBanner;
